export default {
    name: 'DateMixin',

    methods: {
        browserSafeDate(date) {
            // used for Safari and some versions of firefox that don't support dash in date
            return date;
        },
    },
};
